import { gql } from '@apollo/client'

export const GET_CHANNELS = gql`
  query GetChannels($page: Int, $perPage: Int, $subject: String) {
    channels(page: $page, perPage: $perPage, subject: $subject) {
      totalCount
      totalPages
      currentPage
      perPage
      channels {
        id
        subject
        permissionKey
        unread
        createdAt
        updatedAt
        lastMessage {
          id
          text
          createdAt
        }
      }
    }
  }
`

export const GET_CHANNEL = gql`
  query GetChannel($id: ID!) {
    channel(id: $id) {
      id
      subject
      permissionKey
      unread
      createdAt
      updatedAt
      messages {
        id
        text
        subject
        createdAt
        sender {
          id
          fullName
          firstName
          lastName
          email
          avatarUrl
        }
      }
    }
  }
`
